// Pass any error (Axios or not) and get a string for your toast
export function extractAxiosErrorMessage(err) {
  try {
    const res = err?.response;
    const data = res?.data;

    // 1) Prefer explicit message fields from server
    if (typeof data === "string" && data.trim()) return data;
    if (typeof data?.message === "string" && data.message.trim())
      return data.message;
    if (typeof data?.detail === "string" && data.detail.trim())
      return data.detail;
    if (Array.isArray(data?.errors) && data.errors.length) {
      // Join array of error strings or objects with message fields
      const parts = data.errors
        .map((e) =>
          typeof e === "string"
            ? e
            : typeof e?.message === "string"
              ? e.message
              : JSON.stringify(e)
        )
        .filter(Boolean);
      if (parts.length) return parts.join("; ");
    }
    // 2) Field-level validation objects: { field: ["msg1","msg2"], ... }
    if (data && typeof data === "object") {
      const kv = Object.entries(data)
        .filter(([k, v]) => k !== "status" && v != null)
        .flatMap(([k, v]) => {
          if (typeof v === "string") return `${k}: ${v}`;
          if (Array.isArray(v)) return v.map((s) => `${k}: ${String(s)}`);
          if (typeof v === "object") return `${k}: ${JSON.stringify(v)}`;
          return `${k}: ${String(v)}`;
        });
      if (kv.length) return kv.join("; ");
    }

    // 3) Axios top-level message
    if (typeof err?.message === "string" && err.message.trim()) {
      // Optionally include status code if present
      const status = res?.status || err?.status;
      return status ? `${err.message} (HTTP ${status})` : err.message;
    }

    // 4) Generic fallback
    return "An unexpected error occurred";
  } catch {
    return "An unexpected error occurred";
  }
}

export function formatPercentFromFraction(v) {
  if (typeof v !== "number" || Number.isNaN(v)) return "—";
  return `${(v * 100).toFixed(0)}%`;
}

export function formatPercent(v) {
  if (typeof v !== "number" || Number.isNaN(v)) return "—";
  return `${v.toFixed(0)}%`;
}

export function toIsoFromPretty(str) {
  // 1) Drop weekday and ordinal suffix (st/nd/rd/th)
  const withoutWeekday = str.replace(/^[A-Za-z]+,\s*/, ""); // "November 27th, 2025 12:52 PM"
  const cleaned = withoutWeekday.replace(/(\d+)(st|nd|rd|th)/, "$1"); // "November 27, 2025 12:52 PM"

  // 2) Let Date parse the cleaned string
  const d = new Date(cleaned);
  if (Number.isNaN(d.getTime())) {
    throw new Error("Invalid date string");
  }

  // 3) Return ISO 8601 string
  return d.toISOString(); // e.g. "2025-11-27T12:52:00.000Z"
}
